__turbopack_context__.v({
  "quickTaskInlineCreateForm": "N820Zq_quickTaskInlineCreateForm",
  "quickTaskInlineCreateForm__actions": "N820Zq_quickTaskInlineCreateForm__actions",
  "quickTaskInlineCreateForm__contextBlock": "N820Zq_quickTaskInlineCreateForm__contextBlock",
  "quickTaskInlineCreateForm__contextRow": "N820Zq_quickTaskInlineCreateForm__contextRow",
  "quickTaskInlineCreateForm__error": "N820Zq_quickTaskInlineCreateForm__error",
  "quickTaskInlineCreateForm__sectionLabel": "N820Zq_quickTaskInlineCreateForm__sectionLabel",
});
